enum HttpStatus {
    OK = 200,
    NO_CONTENT = 204,
    UNAUTHORIZED = 401,
    NOT_FOUND = 404,
    INTERNAL_SERVER_ERROR = 500
}

export default HttpStatus;
